import { Coordinate } from 'react-map-gl/src/components/draggable-control'
type IGetDistanceBetweenCoords = [Coordinate, Coordinate]

const degreeToRadius = (deg: number) => {
    return deg * (Math.PI / 180)
}

const getDistanceBetweenCoords = (points: IGetDistanceBetweenCoords): number => {
    const pointA = points[0]
    const pointB = points[1]

    const R = 6371
    const dLat = degreeToRadius(pointB[0] - pointA[0])
    const dLon = degreeToRadius(pointB[1] - pointA[1])
    const staticDistance =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(degreeToRadius(pointA[0])) *
            Math.cos(degreeToRadius(pointB[0])) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2)
    const circ = 2 * Math.atan2(Math.sqrt(staticDistance), Math.sqrt(1 - staticDistance))
    const distance = R * circ * 0.621371
    return Number(distance.toFixed(2))
}

export default getDistanceBetweenCoords
